import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { storeOptions } from '../../../../common/remapped-redux/index.tsx';
import type { State } from '../../../../state/index.tsx';
import { getEmptyFilterResultConfiguration } from '../../../../state/selectors/index.tsx';
import DefaultEmptyView from './view.tsx';

const mapStateToProps = <
	TEntity,
	TOperation extends string,
	TSortField extends string,
	TFilter,
	TChildEntityId,
>(
	state: State<TEntity, TOperation, TSortField, TFilter, TChildEntityId>,
) => {
	const configuration = getEmptyFilterResultConfiguration(state);
	// @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
	if (!configuration.message) {
		throw new Error('Invalid state - Default empty view should not be mounted');
	}
	return {
		// @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
		message: configuration.message,
	};
};

export default connect(mapStateToProps, null, null, storeOptions)(DefaultEmptyView);
